import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import includes from 'lodash/includes';
import orderBy from 'lodash/orderBy';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Drawer from 'material-ui/Drawer';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ArrowUpIcon from 'material-ui/svg-icons/navigation/arrow-upward';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';
import CircularProgress from 'material-ui/CircularProgress';
import SearchIcon from 'material-ui/svg-icons/action/search';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import SortIcon from 'material-ui/svg-icons/av/sort-by-alpha';
import { database } from '../../utils/configureFirebase';
import csvConverter from '../../utils/CollegeCSV';
import EarlyBirdCollegeCard from '../../components/EarlyBirdCollegeCard';
import { theme } from '../../utils/getTheme';
import { DateFilter, DataFilter } from '../../components/Filters';
import allCandidates from '../../utils/AllCandidateCSV';

const myanatomy = 'MA#CSV#PASSWORD';

const ContentWrapper = styled.div`
  width: 85%;
  margin: 0 auto;

  & > * + * {
    margin-top: 24px;
  }
`;

const LoaderWrapper = styled.div`
  text-align: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DataWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;

const SearchWrpper = styled.div`
  display: flex;
  justify-content: center;
  align-item: center;
  background-color: white;
  border-radius: 25px;
`;

const ContentContainer = styled.div`
  & > * + * {
    margin-top: 16px;
  }
`;

const CardIcon = styled.div`
  position: absolute;
  top: 2px;
  right: 4px;
`;

const HeaderWrapper = styled.div`
  width: 184px;
`;

const FloatingButtonContianer = styled.div`
  position: fixed;
  bottom: 12px;
  right: 12px;
  color: ${props => props.theme.primary1Color};
  transition: 0.3s ease-in-out;
`;

const FilterButtonContainer = styled.div`
  padding: 4px;
  margin: 4px 0 4px 0;
  display: flex;
  justify-content: flex-end;
`;

class EarlyBirdCollege extends Component {
  constructor(props) {
    super(props);

    this.state = {
      candidates: undefined,
      registerations: undefined,
      isLoading: true,
      csvConfirmationModal: false,
      password: '',
      passwordErrorText: undefined,
      searchText: '',
      filteredData: [],
      drawerOpen: false,
      filters: {},
      alphabeticOrder: true,
      stateFiltered: [],
      emptySearchOpen: false,
    };
  }

  componentDidMount() {
    this.registrationRef = database.ref('contact/college');
    this.registrationRef.on('value', this.setRegistrationData);

    this.candidateRef = database.ref('contact/candidate');
    this.candidateRef.on('value', this.setCandidateData);
  }

  componentWillUnmount() {
    this.registrationRef.off('value', this.setRegistrationData);
  }

  setRegistrationData = (snapshot) => {
    if (snapshot) {
      const registrations = snapshot.val();
      this.setState(() => ({
        registerations: registrations,
      }));
    }
  };

  setCandidateData = (snapshot) => {
    if (snapshot) {
      const candidates = snapshot.val();
      this.setState(() => ({
        candidates,
        isLoading: false,
      }));
    }
  };

  getRegistrations = (registrations, candidates) => {
    if (typeof registrations !== 'undefined') {
      const collegeArr = Object.keys(registrations).map((collegeId) => {
        let count = 0;
        const formattedData = this.formatRegistration(registrations[collegeId]);
        if (candidates && (candidates[collegeId] !== undefined)) {
          count = Object.keys(candidates[collegeId]).length;
        } else {
          count = 0;
        }
        return {
          ...formattedData,
          collegeId,
          count,
        };
      });
      return orderBy(collegeArr, college => college.timestamp, 'desc');
    }
    return [];
  };

  formatRegistration = data => ({
    ...data,
    // dob: formatDate(data.dob),
    certifications: data.certifications === '' ? '-' : data.certifications,
  });

  formattedDate = (timestamp) => {
    const date = new Date(timestamp);
    return `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}-${date.getHours()}:${date.getMinutes()}`;
  };

  openCSVConfirmationModal = () => {
    this.setState(() => ({
      csvConfirmationModal: true,
      passwordErrorText: undefined,
      password: '',
    }));
  };

  closeCSVConfirmationModal = () => {
    this.setState(() => ({
      csvConfirmationModal: false,
    }));
  };

  downloadCSV = (collegeRegistrations) => {
    const { password, filteredData } = this.state;

    if (password === myanatomy) {
      if (filteredData.length === 0) {
        csvConverter(collegeRegistrations, 'EB-College');
      } else {
        csvConverter(filteredData, 'EB-College');
      }
      this.setState(() => ({
        csvConfirmationModal: false,
      }));
    } else {
      this.setState(() => ({
        passwordErrorText: 'PasswordMismatch',
      }));
    }
  };

  searchCollege = (colleges) => {
    const { searchText } = this.state;
    this.setState(() => ({
      isLoading: true,
    }));
    const result = colleges.filter((college) => {
      // eslint-disable-line
      if (
        includes(college.collegeName.toLowerCase(), searchText.toLowerCase())
      ) {
        return college;
      }
      return false;
    });
    if (result.length > 0) {
      this.setState(() => ({
        filteredData: result,
        isLoading: false,
      }));
    } else {
      this.setState(() => ({
        emptySearchOpen: true,
        searchText: '',
        isLoading: false,
        filteredData: [],
      }));
    }
  };

  resetSearch = () => {
    this.setState(() => ({
      searchText: '',
      filteredData: [],
      filters: [],
    }));
  };

  filterValueAdd = (field, value, date = '') => {
    const { filters } = this.state;
    // console.log('Hello ===> ', field, value, date);
    if (typeof filters[field] === 'undefined' && field !== 'timestamp') {
      this.setState(state => ({
        filters: {
          ...state.filters,
          [field]: [value],
        },
        // isLoading: true,
      }));
    } else if (field === 'timestamp') {
      const temporaryFields = filters[field];
      // console.log(date, field, temporaryFields);
      this.setState(state => ({
        filters: {
          ...state.filters,
          [field]: temporaryFields
            ? [
              {
                ...temporaryFields[0],
                [date]: this.formattedDate(value),
              },
            ]
            : [
              {
                [date]: this.formattedDate(value),
              },
            ],
        },
        // isLoading: true,
      }));
    } else {
      this.setState(state => ({
        filters: {
          ...state.filters,
          [field]: [...state.filters[field], value],
        },
        // isLoading: true,
      }));
    }
  };

  formattedDate = (date) => {
    const newDate = new Date(date);
    return `${newDate.getFullYear()}-${newDate.getMonth() +
      1}-${newDate.getDate()}`;
  };

  addFilter = (value, colleges, field, date = '') => {
    this.setState(() => ({
      filteredData: [],
    }));
    const promise = new Promise((resolve, reject) => {
      // eslint-disable-line
      resolve(this.filterValueAdd(field, value, date));
    });

    promise.then(() => {
      let boolArray = [];
      this.setState(state => ({
        filteredData: colleges.filter((college) => {
          boolArray = Object.keys(state.filters).map((filterKey) => {
            let bool = false;
            state.filters[filterKey].forEach((eachFilter) => {
              if (filterKey === 'timestamp') {
                bool =
                  bool ||
                  (this.formattedDate(college[filterKey]) >=
                    (eachFilter.startDate || eachFilter.endDate) &&
                    this.formattedDate(college[filterKey]) <=
                      (eachFilter.endDate || eachFilter.startDate));
              } else {
                bool =
                  bool ||
                  college[filterKey].toLowerCase() === eachFilter.toLowerCase();
              }
            });
            return bool;
          });
          let useBool = true;
          boolArray.forEach((arr) => {
            useBool = useBool && arr;
          });
          return useBool;
        }),
      }));
    });
  };

  removeFilter = (value, colleges, field) => {
    const { filters } = this.state;
    const promise = new Promise((resolve, reject) => {
      // eslint-disable-line
      let dummyFilters = {
        ...filters,
        [field]: filters[field].filter(val => val !== value),
      };
      if (dummyFilters[field].length === 0) {
        const { [field]: r, ...rest } = dummyFilters;
        dummyFilters = { ...rest };
      }
      resolve(
        this.setState(() => ({
          // isLoading: true,
          filters: dummyFilters,
        })),
      );
    });

    promise.then(() => {
      let boolArray = [];
      this.setState(state => ({
        filteredData: colleges.filter((college) => {
          boolArray = Object.keys(state.filters).map((filterKey) => {
            let bool = false;
            state.filters[filterKey].forEach((eachFilter) => {
              if (filterKey === 'timestamp') {
                bool =
                  bool ||
                  (this.formattedDate(college[filterKey]) >=
                    (eachFilter.startDate || eachFilter.endDate) &&
                    this.formattedDate(college[filterKey]) <=
                      (eachFilter.endDate || eachFilter.startDate));
              } else {
                bool =
                  bool ||
                  college[filterKey].toLowerCase() === eachFilter.toLowerCase();
              }
            });
            return bool;
          });
          let useBool = true;
          boolArray.forEach((arr) => {
            useBool = useBool && arr;
          });
          return useBool;
        }),
      }));
    });
  };

  moveToTop = () => {
    document
      .getElementById('headerDiv')
      .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
  };

  clearFilter = () => {
    this.setState(() => ({
      filteredData: [],
      filters: {},
    }));
  };

  alphabeticColleges = (flag, collegeArr) => {
    const { filteredData } = this.state;
    if (filteredData.length === 0) {
      if (flag) {
        return this.setState(() => ({
          filteredData: orderBy(
            collegeArr,
            college => college.collegeName.toLowerCase(),
            'asc',
          ),
          alphabeticOrder: false,
        }));
      }

      return this.setState(() => ({
        filteredData: orderBy(
          collegeArr,
          college => college.collegeName.toLowerCase(),
          'desc',
        ),
        alphabeticOrder: true,
      }));
    }
    if (flag) {
      return this.setState(() => ({
        filteredData: orderBy(
          filteredData,
          college => college.collegeName.toLowerCase(),
          'asc',
        ),
        alphabeticOrder: false,
      }));
    }

    return this.setState(() => ({
      filteredData: orderBy(
        filteredData,
        college => college.collegeName.toLowerCase(),
        'desc',
      ),
      alphabeticOrder: true,
    }));
  };

  downloadCandidateCSV = (candidates, registerations) => {
    //console.log("candidates: ", candidates);
    //console.log("registerations: ", registerations);
    const newData = [];
    Object.keys(candidates).map((collegeID) => {
      //console.log("collegeId: ", collegeID);
      const candidate = candidates[collegeID];
      const collegeName = registerations[collegeID].collegeName;
      const stateName = registerations[collegeID].state;
      const cityName = registerations[collegeID].city;
      const newArray = Object.keys(candidate).map((canID) => {
        const date = new Date(candidate[canID].timestamp);
        return {
          ...candidate[canID],
          time: `${date.getFullYear()}/${date.getMonth() +
            1}/${date.getDate()}-${date.getHours()}:${date.getMinutes()}`,
        };
      });
      for (let i = 0; i < newArray.length; i += 1) {
        newArray[i] = { ...newArray[i], collegeName, stateName, cityName };
        newData.push(newArray[i]);
      }
      return null;
    });
    allCandidates(newData);
  };

  render() {
    const {
      registerations,
      isLoading,
      password,
      passwordErrorText,
      csvConfirmationModal,
      candidates,
      searchText,
      filteredData,
      drawerOpen,
      emptySearchOpen,
      alphabeticOrder,
    } = this.state;
    const { history } = this.props;
    const collegeRegisterations = this.getRegistrations(
      registerations,
      candidates,
    );
    // console.log(collegeRegisterations);
    let candidateCount = 0;
    if (filteredData.length === 0) {
      collegeRegisterations.map((college) => {
        // eslint-disable-line
        candidateCount += college.count;
        return null;
      });
    } else {
      filteredData.map((college) => {
        // eslint-disable-line
        candidateCount += college.count;
        return null;
      });
    }

    return (
      <div id="headerDiv">
        {isLoading ? (
          <ContentContainer>
            <LoaderWrapper>
              <CircularProgress />
            </LoaderWrapper>
          </ContentContainer>
        ) : (
          <div>
            <RaisedButton
              primary
              label="Download All Registered Student Xlsx Sheet"
              onTouchTap={() => {
                this.downloadCandidateCSV(
                  this.state.candidates,
                  registerations,
                );
              }}
            />
            <ContentWrapper>
              <FloatingButtonContianer>
                <FloatingActionButton mini>
                  <ArrowUpIcon onTouchTap={this.moveToTop} />
                </FloatingActionButton>
              </FloatingButtonContianer>
              <DataWrapper>
                <HeaderWrapper>
                  <CardHeader
                    title={`No of Colleges: ${
                      filteredData.length === 0
                        ? collegeRegisterations.length
                        : filteredData.length
                    }`}
                    style={{ paddingLeft: 0, paddingBottom: 0 }}
                    textStyle={{ paddingRight: 0 }}
                  />
                  <CardHeader
                    title={`No of Candidates: ${candidateCount}`}
                    style={{ paddingLeft: 0, paddingBottom: 0, paddingTop: 0 }}
                    textStyle={{ paddingRight: 0 }}
                  />
                </HeaderWrapper>
                <SearchWrpper>
                  <TextField
                    hintText="Search by Name or refrence Id"
                    value={searchText}
                    style={{ marginLeft: 16 }}
                    onChange={(_, value) => {
                      this.setState(() => ({
                        searchText: value,
                      }));
                    }}
                  />
                  {searchText !== '' ? (
                    <IconButton style={{ marginLeft: '-42px' }}>
                      <ClearIcon
                        color={theme.primary1Color}
                        onTouchTap={this.resetSearch}
                      />
                    </IconButton>
                  ) : null}
                  <IconButton>
                    <SearchIcon
                      style={{ height: 48, width: 30 }}
                      color={theme.primary1Color}
                      onTouchTap={() => {
                        this.searchCollege(collegeRegisterations);
                      }}
                    />
                  </IconButton>
                </SearchWrpper>
                <IconButton tooltip="Filter" tooltipPosition="bottom-center">
                  <FilterIcon
                    color={theme.primary1Color}
                    onTouchTap={() => {
                      this.setState(() => ({
                        drawerOpen: !drawerOpen,
                      }));
                    }}
                  />
                </IconButton>
                <IconButton>
                  <SortIcon
                    color={theme.primary1Color}
                    onTouchTap={() => {
                      this.alphabeticColleges(
                        alphabeticOrder,
                        collegeRegisterations,
                      );
                    }}
                  />
                </IconButton>
                <ButtonWrapper>
                  <RaisedButton
                    primary
                    label="Download CSV"
                    onTouchTap={this.openCSVConfirmationModal}
                  />
                </ButtonWrapper>
              </DataWrapper>
              {filteredData.length === 0 ? (
                <ContentContainer>
                  {collegeRegisterations.map(college => (
                    <EarlyBirdCollegeCard
                      key={college.collegeId}
                      {...college}
                      history={history}
                    />
                  ))}
                </ContentContainer>
              ) : (
                <ContentContainer>
                  {filteredData.map(college => (
                    <EarlyBirdCollegeCard
                      key={college.collegeId}
                      {...college}
                      history={history}
                    />
                  ))}
                </ContentContainer>
              )}
            </ContentWrapper>
          </div>
        )}
        <Drawer
          containerStyle={{ top: 64 }}
          openSecondary
          width={216}
          docked={false}
          open={drawerOpen}
          onRequestChange={(open) => {
            this.setState(() => ({
              drawerOpen: open,
            }));
          }}
        >
          <Card zDepth={0} style={{ position: 'relative' }}>
            <CardHeader
              title="Filters"
              style={{ backgroundColor: theme.primary1Color }}
              titleColor={theme.alternateTextColor}
            />
            <CardIcon>
              <IconButton>
                <CloseIcon
                  color={theme.alternateTextColor}
                  onTouchTap={() => {
                    this.setState(() => ({
                      drawerOpen: false,
                    }));
                  }}
                />
              </IconButton>
            </CardIcon>
            <FilterButtonContainer>
              <FlatButton
                label="Clear All"
                primary
                onTouchTap={() => {
                  this.clearFilter();
                }}
              />
            </FilterButtonContainer>
            <DataFilter
              collegeRegisterations={collegeRegisterations}
              addFilter={this.addFilter}
              removeFilter={this.removeFilter}
              // isFieldPresent={this.isChecked}
              field="state"
            />
            <DateFilter
              addFilter={this.addFilter}
              collegeRegisterations={collegeRegisterations}
            />
          </Card>
        </Drawer>
        <Dialog
          title="Download"
          modal
          actions={[
            <FlatButton
              label="Cancel"
              primary
              onTouchTap={this.closeCSVConfirmationModal}
            />,
            <RaisedButton
              label="Download"
              primary
              onTouchTap={() => {
                this.downloadCSV(collegeRegisterations);
              }}
            />,
          ]}
          onRequestClose={this.closeCSVConfirmationModal}
          open={csvConfirmationModal}
        >
          <CardText>
            <TextField
              floatingLabelText="Please Enter password to Download"
              type="password"
              value={password}
              onChange={(_, value) => {
                this.setState(() => ({
                  password: value,
                }));
              }}
              errorText={passwordErrorText}
            />
          </CardText>
        </Dialog>
        <Snackbar
          bodyStyle={{
            backgroundColor: theme.primary1Color,
            textAlign: 'center',
          }}
          open={emptySearchOpen}
          message="No result found"
          autoHideDuration={5000}
          onRequestClose={() => {
            this.setState(() => ({
              emptySearchOpen: false,
            }));
          }}
        />
      </div>
    );
  }
}

EarlyBirdCollege.propTypes = {
  history: PropTypes.object.isRequired, // eslint-disable-line
};

export default EarlyBirdCollege;



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCollege/EarlyBirdCollege.js